import React from "react";
import EcoFactBgImg from "../../assets/new/eco-factbg.png";
import EcoBoost1Icon from "../../assets/new/eco-boost/Icon-1.png";
import EcoBoost2Icon from "../../assets/new/eco-boost/Icon.png";
import EcoBoostMobileImg from "../../assets/new/eco-boost-mobile.png";
import "./index.css";

// TODO: This file is a first step in orgranising this code base.
// Initially everything was just dumped into Landing/index.js which made it very hard to maintain.
// In the near future, we want to simplify this code and make this component responsive with media queries
// as opposed to using isMobileView to keep our code DRY.

export default function EcoBoost({
  selectedBoostTab,
  setSelectedBoostTab,
  isMobileView,
}) {
  return isMobileView ? (
    <div
      className="C-Eco-Full-Section eco-boost-mobile-container"
      style={{ zIndex: 10 }}
    >
      <img className="eco-boost-bg" src={EcoFactBgImg} alt="eco fact img"></img>
      <div className="C-Eco-Full-Content">
        <div
          className={`eco-boost-card ${selectedBoostTab === 0 ? "active" : ""}`}
          onClick={() => setSelectedBoostTab(0)}
        >
          <div className="eco-boost-card-icon">
            <img src={EcoBoost1Icon} alt="eco boost first card icon" />
          </div>
          <div className="eco-boost-card-title poppins-semibold">Engage</div>
          <div className="eco-boost-card-description">
            Your platform smoothly integra
            <br /> -tes into your engagement
            <br /> strategy UX to build on touch
            <br /> points, cultivate loyalty and
            <br /> drive new conversions,
            <br />
            <br /> Our team will help you build
            <br /> flows and you’ll only pay for
            <br /> active users, as we are
            <br /> hand-in-hand on aims.
          </div>
        </div>
        <div
          className={`eco-boost-card ${selectedBoostTab === 1 ? "active" : ""}`}
          onClick={() => setSelectedBoostTab(1)}
        >
          <div className="eco-boost-card-icon">
            <img src={EcoBoost2Icon} alt="eco boost first card icon" />
          </div>
          <div className="eco-boost-card-title poppins-semibold">Entice</div>
          <div className="eco-boost-card-description">
            Reward members with points,
            <br /> in return for their valued
            <br /> actions, to spend on your
            <br /> product or service.
            <br />
            <br /> Utilise your new suite of top
            <br /> retailers and brands to entice
            <br /> interactions with desired
            <br /> actions e.g referring friends
            <br /> or completing a survey.
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="Div-Ecosystem">
      <h2 className="eco-boost__heading section-title poppins-bold">
        Super-boosting your retention and growth
      </h2>
      <div className="eco-boost-cards-container">
        <div
          className={`eco-boost-card ${selectedBoostTab === 0 ? "active" : ""}`}
          onClick={() => setSelectedBoostTab(0)}
        >
          <div className="eco-boost-card-icon">
            <img src={EcoBoost1Icon} alt="eco boost first card icon" />
          </div>
          <div className="eco-boost-card-title poppins-semibold">Engage</div>
          <div className="eco-boost-card-description">
            Your platform smoothly integrates
            <br /> into your engagement strategy UX
            <br />
            to build on touch points, cultivate
            <br />
            loyalty and drive new conversions,
            <br />
            <br />
            Our team will help you build flows
            <br /> and you’ll only pay for active users,
            <br /> as we are hand-in-hand on aims.
            <br />
          </div>
        </div>
        <img
          className="eco-boost-mobile"
          src={EcoBoostMobileImg}
          alt="eco boost mobile"
        />
        <div
          className={`eco-boost-card ${selectedBoostTab === 1 ? "active" : ""}`}
          onClick={() => setSelectedBoostTab(1)}
        >
          <div className="eco-boost-card-icon">
            <img src={EcoBoost2Icon} alt="eco boost first card icon" />
          </div>
          <div className="eco-boost-card-title poppins-semibold">Entice</div>
          <div className="eco-boost-card-description">
            Reward members with points, in
            <br /> return for their valued actions, to
            <br /> spend on your product or service.
            <br />
            <br /> Utilise your new suite of top retailers
            <br /> and brands to entice interactions
            <br /> with desired actions e.g referring
            <br /> friends or completing a survey.
          </div>
        </div>
      </div>
    </div>
  );
}
